import React from 'react';
import { useMediaQuery } from 'react-responsive';
import DomainResults from '../../presentation/DomainResults/DomainResults';
import HomepageContent from './HomepageContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({
  open,
  domainName,
  handleKeyDown,
  handleDomainOpen,
  handleOnChange,
}) => (
  <Mobile>
    {open ? (
      <DomainResults domainName={domainName} />
    ) : (
      <HomepageContent
        domainName={domainName}
        handleKeyDown={handleKeyDown}
        handleDomainOpen={handleDomainOpen}
        handleOnChange={handleOnChange}
      />
    )}
  </Mobile>
);

export default MobileResponsive;
